/**
 * Shared agent portal payment capability checks (wallet / credit / HYBRID).
 * Keep in sync with AgentLayout sidebar gating.
 */

export function getAgentPaymentNavState(agent) {
  const caps = agent?.agent_payment_capabilities || {};
  const isCreditAgent = Boolean(
    caps.credit_enabled
      || ['CREDIT', 'HYBRID'].includes(agent?.payment_mode)
      || Number(agent?.credit_limit || 0) > 0,
  );
  const walletNavHidden = caps.wallet_enabled === false;
  const walletEnabled = !walletNavHidden;
  const isHybrid = walletEnabled && isCreditAgent
    && (agent?.payment_mode === 'HYBRID'
      || (caps.wallet_enabled !== false && caps.credit_enabled === true));

  return {
    caps,
    isCreditAgent,
    walletNavHidden,
    walletEnabled,
    isHybrid,
  };
}

/** Sidebar labels for wallet / credit management (paths only; icons added in layout). */
export function getAgentPaymentNavPaths(agent) {
  const { isCreditAgent, walletNavHidden } = getAgentPaymentNavState(agent);
  return {
    wallet: walletNavHidden ? null : '/agent/wallet',
    credit: isCreditAgent ? '/agent/credit' : null,
  };
}

/** Top-bar / header balance display derived from payment capabilities. */
export function getAgentBalanceDisplay(agent) {
  const { isCreditAgent, walletEnabled, isHybrid } = getAgentPaymentNavState(agent);

  return {
    showWallet: walletEnabled,
    showCredit: isCreditAgent,
    walletAmount: Number(agent?.wallet_balance || 0),
    creditAmount: Number(agent?.credit_available || 0),
    walletLabel: 'Wallet Balance',
    creditLabel: 'Credit Available',
    isHybrid,
  };
}

export function agentCreditInvoicePdfUrl(apiBase, cycleId) {
  const base = (apiBase || '').replace(/\/$/, '');
  return `${base}/api/agent/credit/billing/${cycleId}/invoice.pdf`;
}
